import React from "react";

const colorMap = (score) => {
  if (score >= 75) return "bg-green-100 text-green-800 border-green-300";
  if (score >= 50) return "bg-yellow-100 text-yellow-800 border-yellow-300";
  return "bg-red-100 text-red-800 border-red-300";
};

export default function ScoreBadge({ score }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-semibold border ${colorMap(score)}`}
    >
      {score}
    </span>
  );
}
